import FetchService from '../services/fetchService';
import urlService from '../services/urlService';
import { updatePaymentDescription } from './updatePaymentDescription';

const getBillData = ({ rideId, setBill, setLoading }) => {
  if (!rideId) return;
  setLoading(true);
  return FetchService.getWebApiResource(urlService.getRide(rideId))
    .then(response => {
      let { bill, bill: { total } = {} } = response || {};
      const { items, ...restBill } = bill || {};
      total = total ? total / 100 : 0;
      if (Object.keys(items).length) {
        const { base_fare: fare, tip, ...restItems } = items;
        bill = { total, items: { fare, ...restItems, tip }, ...restBill };
      }
      setBill(bill);
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      console.error(error);
    });
};

export default getBillData;
